import Vue from 'vue';
import Vuex from 'vuex';
import AWN from "awesome-notifications";
import axios from 'axios';
import moment from 'moment';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    notifier: null,
    selectedAccountCode: '',//TBI
    organisationSettings: {},
    orgSettings: {},
    settings: {},
    utilitySettings: { isValid: false }, //Utility/GetSettings
    selectedAccount: {},
    profileDetails: {},
    disableLoginButton: { text: null, date: null, disabled: true, description: '' },
  },
  mutations: {
    initNotifier(state, payload) {
      state.notifier = new AWN(payload.options);
    },
    setSelectedAccountCode(state, payload) {
      state.selectedAccountCode = payload;
    },
    setSettings(state, payload) {
      state.settings = payload;
    },
    setOrgSettings(state, payload) {
      state.orgSettings = payload;
    },
    setProfileDetails(state, payload) {
      state.profileDetails = payload;
    },
    setUtilitySettings(state, payload) {
      state.utilitySettings = payload;
    },
    setSelectedAccount(state, payload) {
      state.selectedAccount = payload;
    },
    setDisableLoginButtonDate(state, date) {
      if (date && moment(date).isSameOrAfter(moment())) {
        state.disableLoginButton.date = date;
        state.disableLoginButton.disabled = true;
      }
      else
        state.disableLoginButton.disabled = false;
    },
    setDisableLoginButtonDescription(state, payload) {
      state.disableLoginButton.description = payload;
    },
    setDisableLoginButtonText(state, payload) {
      state.disableLoginButton.text = payload;
    },
  },
  getters: {
    getSettings(state) {
      return state.settings;
    },
    getOrgSettings(state) {
      return state.orgSettings;
    },
    getProfileDetails(state) {
      return state.profileDetails;
    },
    getSelectedAccount(state) {
      return state.selectedAccount;
    },
    getDisableLoginButton(state) {
      return state.disableLoginButton;
    },
  },
  actions: {
    getUtilitySettings({ commit, state }) {
      if (state.utilitySettings && state.utilitySettings.isValid == true)
        return state.utilitySettings;

      return new Promise((resolve, reject) => {
        let exitFunc = () => {
          resolve(state.utilitySettings);
          reject(state.utilitySettings);
        };


        if (state.utilitySettings.isValid == false) {
          //get settings
          axios.post('/Utility/GetSettings')
            .then(response => {
              if (response.data.data.status == 0) {
                response.data.value['isValid'] = true;
                commit("setUtilitySettings", response.data.value);
              }
            })
            .catch(err => commit("setUtilitySettings", { isValid: false, error: err }))
            .finally(() => {
              exitFunc();
            });
        }
        else
          exitFunc();
      })
    },
  },
});
